import { Cascader, CascaderProps } from 'antd'
import styles from './ACascader.module.less'
import cls from 'classnames'
import { DownIcon } from '../ASelect/ASelect'
import AIcon from '../AIcon/AIcon'
import { useState } from 'react'

type ACascaderProps = Pick<
  CascaderProps,
  'options' | 'onChange' | 'className' | 'placeholder' | 'value' | 'onSearch' | 'showSearch'
> & {
  testId?: string
}

const COMPONENT_NAME = 'A-Cascader'
function ACascader(props: ACascaderProps) {
  const classNames = cls(styles[COMPONENT_NAME], props.className)
  const popupClassName = cls(styles['A-Cascader-popup'], props.testId && `${props.testId}-popup`)
  const [value, setValue] = useState<string[]>([])
  return (
    <Cascader
      data-testid={props.testId}
      className={classNames}
      variant='borderless'
      placeholder={props.placeholder}
      expandIcon={<ExpandIcon />}
      suffixIcon={<DownIcon />}
      options={props.options}
      onSearch={props.onSearch}
      showSearch={props.showSearch}
      onChange={(value, selectOptions) => {
        const v = value as string[]
        setValue(v)
        props.onChange?.(value, selectOptions)
      }}
      popupClassName={popupClassName}
      displayRender={(label) => {
        return label[1]
      }}
      optionRender={(option) => {
        return (
          <div
            className={cls(styles.option, { [styles.active]: value && value.includes(`${option.value}`) })}
          >
            <span className={styles.optionLabel}>{option.label}</span>
            {value && value.includes(`${option.value}`) && !option.children && (
              <span>
                <SelectedIcon />
              </span>
            )}
          </div>
        )
      }}
    />
  )
}

function ExpandIcon() {
  return <AIcon width={11} height={11} style={{ color: '#8C8C8C' }} type='icon-line-global_right' />
}

function SelectedIcon() {
  return <AIcon style={{ color: '#6D54FA' }} type='icon-line-global_check' />
}

export default ACascader
